// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"989":"ef318e6f6e018140","5558":"46e54741ff67af7f"}[chunkId] + ".css";
};